<div id="print-section" class="contract">
  <div class="contract__title">
    <h1>CONTRATO PARA A PRESTAÇÃO DE SERVIÇOS DE AVERBAÇÃO DE CONSTRUÇÃO POR MERA NOTÍCIA</h1>
  </div>
  <div class="contract__personal-data">
    <table class="contract__table">
      <tr>
        <td>
          <p>
            Por este instrumento particular, de um lado,
            <strong>NOME:</strong> {{ proprietario?.name }},
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>CPF:</strong> {{ proprietario?.cpf | mask: '000.000.000-00' }},
            <strong>RG:</strong> {{ proprietario?.rg?.number || '' }}, <strong>EMISSOR/UF: </strong>
            {{ proprietario?.rg?.issuer || '' }}/{{ proprietario?.rg?.state || ''}}
          </p>
        </td>
      </tr>
      <tr *ngIf="(proprietario?.maritalStatus === estadoCivil.MARRIED) && conjuge ">
        <td>
          <p>
            <strong>CÔNJUGE/COMPANHEIRO:</strong> {{ conjuge?.name }},
            <strong>CPF:</strong> {{ conjuge?.cpf | mask: '000.000.000-00' }}
          </p>
        </td>
      </tr>
      <tr *ngIf="cadastro?.reurbModalidade">
        <td>
          <p>
            <strong>Condições REURB:</strong> Renda Familiar menor que 5(cinco) salários mínimos
            e não ter sido beneficiado pela REURB anteriormente. <br />
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_S ? 'X' : '' }} ) REURB–S ou
            ( {{ cadastro.reurbModalidade === reurbModalidade.REURB_E ? 'X' : '' }} ) REURB–E
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Qual o segmento de uso do imóvel:</strong>
            ( {{ imovel?.usage === imovelTipo.RESIDENTIAL ? 'X' : '' }} ) Residencial
            ( {{ imovel?.usage === imovelTipo.COMMERCIAL ? 'X' : '' }} ) Comercial
            ( {{ imovel?.usage === imovelTipo.MIXED ? 'X' : '' }} ) Misto
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Estado Civil:</strong>
            ( {{ proprietario?.maritalStatus === estadoCivil.MARRIED ? 'X' : '' }} ) Casado(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SINGLE ? 'X' : '' }} ) Solteiro(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.WIDOWED ? 'X' : '' }} ) Viúvo(a)
            ( {{ proprietario?.maritalStatus === estadoCivil.SEPARATED ? 'X' : '' }} ) Separado(a)
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>E-mail: </strong> {{ proprietario?.email }}
            <strong>Telefone: </strong>
            {{ proprietario?.phones?.cellphone ? (proprietario.phones.cellphone | mask: '(00) 00000-0000') : ''}}
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <strong>Observações (situação jurídica, endereço, quadra e lote): </strong>
          </p>
        </td>
      </tr>
    </table>

    <p>Doravante denominados <strong>"{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}"</strong>; e, de outro lado,
      <strong>USU CAMPEÃO INCORPORAÇÃO, LOTEAMENTO E URBANIZAÇÃO SOCIAL LTDA.</strong>, pessoa jurídica de direito
      privado, com SEDE na Rua Cláudio Soares 72, conj. 615 Pinheiros, São Paulo – SP, inscrita no CNPJ/MF, sob o nº
      <strong>36.174.049/0001-08</strong> e FILIAL Rua José Rodrigues Pereira 514, Estoril, Belo Horizonte – MG sob o nº
      <strong>36.174.049/0002-99</strong>, neste ato representada
      de acordo com seus atos constitutivos, doravante denominado <strong>"USUCAMPEÃO"</strong>, celebram o presente
      <strong>CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE AVERBAÇÃO DE CONSTRUÇÃO POR MERA NOTICIA</strong>, regido pelas
      seguintes cláusulas:
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Primeira – OBJETO</h2>
    <p>
      <strong>1.1.</strong> Este Contrato estabelece as condições pelas quais a <strong>USUCAMPEÃO</strong> prestará
      {{ conjuge ? 'aos' : 'ao' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      serviços de “Averbação Edilícia”, na forma do artigo 63 da Lei 13.465/17, na matrícula acima citada.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Segunda – RESPONSABILIDADE DAS PARTES</h2>
    <p>
      <strong>2.1.</strong> São obrigações {{ conjuge ? 'dos' : 'do' }} <strong>{{ conjuge ? 'CONTRATANTES' :
        'CONTRATANTE' }}</strong> efetuar o pagamento na forma da Cláusula Terceira e fornecer todas as informações e
      documentos solicitados pela USUCAMPEÃO na execução dos Serviços.
    </p>
    <p>
      <strong>2.2.</strong> {{ conjuge ? 'Os' : 'O' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'comprometem-se' : 'compromete-se' }} a apresentar à USUCAMPEÃO no prazo de até 15 dias corridos
      todos e quaisquer documentos que forem solicitados, incluindo assinaturas em documentos, declarações e
      procurações, sob pena de não ser incluído nas listagens a serem enviadas para os entes municipais e registros de
      imóveis.
    </p>
    <p>
      <strong>2.3.</strong> São obrigações da USUCAMPEÃO a execução dos Serviços constantes na Cláusula Primeira e no
      Anexo 1 (escopo do serviço).
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Terceira – REMUNERAÇÃO E FORMA DE PAGAMENTO</h2>

    <p>
      <strong>3.1.</strong> Pela prestação dos Serviços, {{ conjuge ? 'os' : 'o' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> {{ conjuge ? 'pagarão' : 'pagará' }} <strong>o
        valor total de</strong> {{ cadastro?.valorServico | currency: 'BRL'}}
      ({{cadastro.valorServico | numeroExtenso: numeroExtensoTipo.MONETARIO}}),
      {{ pagamentoAVista ? 'no ato de assinatura' : 'parcelado e/ou no ato de assinatura' }} deste contrato e nos
      termos descritos no <strong>ANEXO II – DISPOSIÇÕES FINANCEIRAS.</strong>
    </p>

    <ng-container *ngIf="!pagamentoAVista">
      <p>
        <strong>3.2.</strong> Finalizado o projeto técnico, ANTES de encaminhar para o registrador imobiliário
        competente, a <strong>USUCAMPEÃO</strong> entrará em contato com {{ conjuge ? 'os' : 'o' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> para oferecer as seguintes opções:
      </p>
      <ul>
        <li>
          <strong>3.2.1.</strong> <u>Efetuar a quitação total do preço pactuado</u>. Neste caso, o requerimento será
          enviado ao registrador imobiliário para proceder a averbação de construção edilícia.
        </li>
        <li>
          <strong>3.2.2.</strong> Continuar pagando o preço de forma parcelada,
          como pactuado neste instrumento e no ANEXO II – DISPOSIÇÕES FINANCEIRAS. Neste caso, a averbação de construção
          edilícia somente será finalizada após a quitação integral do preço, ou seja, após a finalização do
          parcelamento. Assim sendo, após a finalização do parcelamento, a <strong>USUCAMPEÃO</strong> apresentará ao
          registrador imobiliário o requerimento e demais documentos técnicos, na forma do artigo 63 da Lei 13.465/17.

        </li>
        <li>
          <strong>3.2.3.</strong> Em ambos os casos, a averbação de construção edilícia ocorrerá variando apenas o
          momento em que ocorrerá.
        </li>
        <li>
          <strong>3.2.4.</strong> A <strong>USUCAMPEÃO</strong> poderá, se entender viável, após análise técnica e
          financeira, dispensar a tramitação prevista no item anterior, já enviando ao registrador imobiliário o
          requerimento e demais documentos técnicos para averbação.
        </li>
      </ul>
      <p><strong>3.3.</strong> Havendo impontualidade no cumprimento da obrigação
        {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>,
        {{ conjuge ? 'estes incorrerão' : 'este incorrerá' }} em multa de 2% (dois por cento) sobre o valor em atraso
        corrigido e juros moratórios de 1% (um por cento) ao mês, sob o valor devido.
      </p>
    </ng-container>
  </div>

  <div class="clause">
    <h2>Cláusula Quarta – DOS DIREITOS AUTORAIS</h2>
    <p>{{ conjuge ? 'Ficam os' : 'Fica o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> cientes de
      que todos os projetos técnicos que serão apresentados para a Prefeitura, são de uso exclusivo da
      <strong>USUCAMPEÃO</strong>, a qual detém os direitos autorais sobre eles.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Quinta – DOS PRAZOS E OUTRAS CONDIÇÕES</h2>
    <p>
      <strong>5.1.</strong> {{ conjuge ? 'Os' : 'O' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      tem conhecimento de que o presente contrato apenas torna-se válido e eficaz caso já tenha sido titulado na
      matrícula apontada no preâmbulo deste instrumento através de quaisquer dos institutos de regularização fundiária
      previstos na Lei 13.465/17.
    </p>
    <p>
      <strong>5.2.</strong> A <strong>USUCAMPEÃO</strong> se compromete a responder as devolutivas e atender eventuais
      exigências realizadas pelo Oficial de Registro de Imóveis no prazo máximo de validade da Prenotação Registral.
      Caso não seja possível a resposta por motivos técnicos, o atendimento da devolutiva deverá ser realizado através
      de nova prenotação, no prazo máximo de 120 dias.
    </p>
    <p>
      <strong>5.3.</strong> Em caso de transmissão da unidade imobiliária a terceiros, seja a que título for,
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> se responsabiliza a
      informar imediatamente à <strong>USUCAMPEÃO</strong> para a devida formalização do instrumento particular de
      cessão dos direitos e obrigações aqui formalizados. A <strong>USUCAMPEÃO</strong> não se responsabilizará por erro
      referente à titulação da unidade decorrente da ausência da mencionada comunicação.
    </p>
    <p>
      <strong>5.4.</strong> Considerando que o processo de regularização fundiária e seus acessórios devem demonstrar a
      realidade fática dos imóveis, todas as medições realizadas pela equipe técnica serão realizadas em conformidade
      com a realidade aos qual os imóveis se encontram, mesmo que a descrição, perímetro, áreas e construção estejam
      divergentes com os contratos de aquisição apresentados {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
    </p>
    <p>
      <strong>5.5.</strong> Antes da apresentação dos documentos referentes à
      Prefeitura para emissão da CRF, será enviada através da plataforma <i>“Voce Pode Regularizar”</i> ou por meio
      eletrônico (e-mail ou WhatsApp) para conhecimento a denominada “planta de anuência”, devidamente acompanhada de
      memorial descritivo, que conterá as medidas individuais apuradas in loco do lote {{ conjuge ? 'dos' : 'do' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>. Havendo discordância com as medidas apresentadas
      a contestação deverá ser apresentada em <strong><u>15 dias corridos</u>. A ausência de manifestação acarretará em
        concordância com as medidas apresentadas.</strong>
    </p>
    <p>
      <strong>5.6.</strong> Conforme mencionado no item 5.1 deste instrumento, a averbação edilícia, por ser ato
      acessório, fica condicionada à aprovação e registro da REURB.
    </p>
    <p>
      <strong>5.7.</strong> Não estão contempladas neste contrato, despesas com tributos inerentes à unidade
      imobiliária, taxas/preços públicos municipais e emolumentos de cartórios.
    </p>
    <p>
      <strong>5.8.</strong> Não estão contemplados neste contrato, eventuais procedimentos judiciais que sejam
      necessários para a viabilização da regularização.
    </p>
    <p>
      <strong>5.9.</strong> Estão contemplados neste contrato, os procedimentos de dúvida junto ao Cartório de Registro
      de Imóveis, quando necessário.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Sexta – RESCISÃO</h2>
    <p>
      <strong>6.1.</strong> Este Contrato poderá ser rescindido imotivadamente {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>, desde que seja enviada
      notificação prévia, com antecedência mínima de 15 (quinze) dias, gerando as seguintes consequências:
    </p>
    <ul>

      <li>
        <strong>6.1.1.</strong> Rescisão antes da medição técnica da construção a ser averbada: Multa de 10% sobre o
        valor do total do contrato e retenção de 10%, calculada sobre o valor pago {{ conjuge ? 'pelos' : 'pelo' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
      </li>

      <li>
        <strong>6.1.2.</strong> Rescisão após medição técnica da construção a ser averbada: Multa de 10% sobre o valor
        total do contrato e retenção de 60% calculada sobre o valor pago {{ conjuge ? 'pelos' : 'pelo' }}
        <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
      </li>
      <li>
        <strong>6.1.3.</strong> Rescisão após protocolo do pedido de averbação junto ao Cartório de Registro de
        Imóveis: Multa de 10% sobre o valor total do contrato e retenção de 80% calculada sobre o valor já pago
        {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
      </li>
    </ul>

    <p>
      <strong>6.2.</strong> No caso de rescisão por motivo de negativa de AVERBAÇÃO por parte do Cartório de Registro de
      Imóveis, por fato não atribuível à <strong>USUCAMPEÃO</strong>, não haverá a restituição de nenhum dos valores
      pagos até o momento do indeferimento.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Sétima – DISPOSIÇÕES GERAIS</h2>
    <p>
      <strong>7.1.</strong> A USUCAMPEÃO poderá ceder o recebível para instituições financeiras, ficando expressamente
      autorizada para tanto {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>.
    </p>
    <p>
      <strong>7.2.</strong> Nenhuma das Partes poderá ser considerada como inadimplente de suas obrigações contratuais
      se tal fato for resultante de caso fortuito ou força maior.
    </p>
    <p>
      <strong>7.3.</strong> O presente Contrato se refere exclusivamente ao serviço de regularização fundiária na
      esfera administrativa perante a Prefeitura e Oficiais de Registro de Imóveis.
    </p>
    <p>
      <strong>7.4.</strong> As obrigações aqui pactuadas ficam condicionadas ao pagamento do valor integral pactuado na
      Cláusula Terceira. Em caso de não cumprimento, o presente instrumento torna-se ineficaz.
    </p>
  </div>

  <div class="clause">
    <h2>Cláusula Oitava – FORO E ASSINATURA</h2>
    <p>
      <strong>8.1.</strong> As PARTES declaram que o início efetivo da prestação de serviços, bem como de todas as
      demais obrigações oriundas deste instrumento, será considerada a data de pagamento da entrada e/ou da primeira
      parcela, ANEXO II – DISPOSIÇÕES FINANCEIRAS.
    </p>
    <p>
      <strong>8.2.</strong> Para dirimir quaisquer controvérsias oriundas deste Contrato, as Partes elegem o Foro da
      Comarca de ...., Estado ......
    </p>
    <p>
      <strong>8.3.</strong> As <strong>PARTES</strong>, de forma irrevogável e irretratável, afirmam e declaram que o
      presente instrumento poderá ser assinado eletronicamente mediante: (i) impressão, assinatura e digitalização e
      reenvio deste termo; (ii) envio de código por e-mail cadastrado; (iii) envio de código por mensagem de celular ou
      Whatsapp cadastrado; ou (iv) envio de foto segurando o documento pessoal. Seja qual for a forma escolhida
      {{ conjuge ? 'pelos' : 'pelo' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>,as
      <strong>PARTES</strong> a consideram válida e aceita, com fundamento no art. 10º, §2º da MP 2200-2/2001, e do art.
      6º do Decreto 10.278/2020, sendo a forma que for, as assinaturas serão consideradas válidas, vinculantes e
      executáveis, desde que firmadas pelos representantes legais das <strong>PARTES</strong>.
    </p>
    <p>
      E, por estarem assim, justas e contratadas, firmam o presente Contrato em 2 (duas) vias de igual teor e forma, na
      na presença das testemunhas abaixo, para que produza seus regulares efeitos de direito.
    </p>

    <p>{{ cadastro?.projetoMunicipio }}, {{ cadastro?.contractDate | date: 'longDate'}}.</p>
  </div>

  <div class="contract__subscription" *ngIf="isPrint">
    <div class="contract__subscription__table">
      <div class="contract__subscription__column">
        <p>______________________________________________</p>
        <p>CONTRATANTE/OUTORGANTE</p>
        <div class="contract__subscription__column__infos">
          <p>Representante: {{ proprietario?.name }}</p>
          <p>CPF: {{ proprietario?.cpf }}</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-left">
        <img class="contract__ceo-subscription" alt="Assinatura CEO" src="/assets/images/assinatura.svg" />
        <p>______________________________________________</p>
        <p>NATHALIE ROMANO</p>
        <div class="contract__subscription__column__infos">
          <p>USUCAMPEÃO</p>
          <p>CNPJ: 36.174.049/0001-08</p>
        </div>
      </div>
      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 1: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>

      <div class="contract__subscription__column contract__subscription__column--no-border-top">
        <p>______________________________________________</p>
        <div class="contract__subscription__column__infos">
          <p>Testemunha 2: _______________________________</p>
          <p>CPF:</p>
        </div>
      </div>
    </div>
  </div>

  <div class="anexo">
    <h2>ANEXO I</h2>
    <h3>ESCOPO DO SERVIÇO</h3>
    <p>
      <strong>1.1.</strong> Análise da matrícula do imóvel do CONTRATANTE para confirmação de sua condição de
      proprietário.
    </p>
    <p>
      <strong>1.2.</strong> Medição Técnica da construção a ser averbada, com elaboração do documento técnico
      pertinente e recolhimento dos emolumentos relativos á responsabilidade técnica.
    </p>
    <p><strong>1.3.</strong> ART</p>
    <p>
      <strong>1.4.</strong> Requerimento e acompanhamento do mesmo junto ao Cartório de Registro de Imóveis,
      solicitando a averbação da construção.
    </p>
  </div>

  <div class="anexo">
    <h2>ANEXO II</h2>
    <h3>DISPOSIÇÕES FINANCEIRAS</h3>
    <p>
      <strong>1.1.</strong> Este termo estabelece as DISPOSIÇÕES FINANCEIRAS entre a USUCAMPEÃO e
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      para a realização dos serviços de regularização fundiária “REURB” celebrados no respectivo instrumento.
    </p>
    <p>
      <strong>1.2.</strong> Pela prestação de serviços objeto do presente instrumento firmado entre as partes,
      {{ conjuge ? 'os' : 'o' }} <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong>
      {{ conjuge ? 'pagarão' : 'pagará' }} a quantia de {{ cadastro.valorServico | currency: 'BRL' }}
      ({{cadastro?.valorServico | numeroExtenso: numeroExtensoTipo.MONETARIO}}).
    </p>
    <p>
      <strong>1.3.</strong> Será aplicado desconto de {{ cadastro.descontoPorcentagem || 0 }}%
      ({{cadastro?.descontoPorcentagem | numeroExtenso: numeroExtensoTipo.PORCENTAGEM}}), referente à:
    </p>
    <ul>
      <li>Evento ( )</li>
      <li>Campanha ( )</li>
      <li>
        Cupom ( {{ cadastro.cupomDescontoCodigo ? 'X' : '' }} )
        <i> {{ cadastro.cupomDescontoCodigo ? cadastro.cupomDescontoCodigo : '' }} </i>
      </li>
      <li>Pagamento à vista ( {{ isPagamentoAVista ? 'X' : '' }} )</li>
    </ul>
    <p><strong>1.4.</strong> A forma de pagamento será:</p>
    <ul>
      <li>Boleto Bancário ( {{ cadastro.meioPagamento === meioPagamento.BOLETO ? 'X' : '' }} )</li>
      <li>Dinheiro ( {{ cadastro.meioPagamento === meioPagamento.PIX ? 'X' : '' }} )</li>
      <li>Cartão ( {{ cadastro.meioPagamento === meioPagamento.CARTAO_CREDITO ? 'X' : '' }} )</li>
      <li>Carnê ( )</li>
    </ul>
    <p>
      <strong>1.5.</strong> A consulta da situação financeira para com os pagamentos poderá ser acessada pelo APP, site
      da USUCAMPEÃO ou ainda {{ conjuge ? 'pelos' : 'pelo' }}
      <strong>{{ conjuge ? 'CONTRATANTES' : 'CONTRATANTE' }}</strong> via:
    </p>
    <ul>
      <li>Whatsapp para o número (11) 97123-3055; ou</li>
      <li>E-mail para o endereço contato&#64;usucampeao.com.br</li>
    </ul>

    <div class="financial-table">
      <p><strong>2.</strong> Tabela de Valores:</p>

      <usucampeao-tabela-valores [cadastro]="cadastro"></usucampeao-tabela-valores>
    </div>
  </div>
</div>